import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Fetch a protected file via authenticated XHR and open it in a new tab.
 * Works around httpOnly cookie edge-cases (popups, mobile browsers, iframes).
 */
export async function openProtectedFile(path) {
  try {
    const { data } = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
      // Popup blocked — fallback: trigger a download via anchor click
      const a = document.createElement("a");
      a.href = url;
      a.rel = "noopener noreferrer";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    toast.error("Could not open file");
  }
}
